"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerseRouterController = void 0;
var ethers_1 = require("ethers");
var utils_1 = require("ethers/lib/utils");
var VerseRouter_1 = require("../../contracts/VerseRouter");
var Result_1 = __importDefault(require("../../Result"));
var errors_1 = require("./errors");
/**
 * Handles all the router
 */
var VerseRouterController = /** @class */ (function () {
    function VerseRouterController(signer, routerAddress) {
        this._MILLISECONDS_ADJUST = 1000;
        this._SECONDS_IN_MINUTE = 60;
        this._signer = signer;
        this._routerContract = new ethers_1.Contract(routerAddress, new utils_1.Interface(VerseRouter_1.ABI), this._signer);
    }
    VerseRouterController.prototype.getFutureTimeStamp = function (minutes) {
        var timeNow = new Date().getTime();
        var timeNowInSeconds = Math.ceil(timeNow / this._MILLISECONDS_ADJUST);
        var futureTimeStamp = timeNowInSeconds + minutes * this._SECONDS_IN_MINUTE;
        return futureTimeStamp;
    };
    /**
     * Get's the router pair address for two given tokens
     *
     * @param factoryAddress string - factory address
     * @param tokenA string - token a id
     * @param tokenB string - token b id
     * @returns string
     */
    VerseRouterController.prototype.getPairFor = function (factoryAddress, tokenA, tokenB) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._routerContract.pairFor(factoryAddress, tokenA, tokenB)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(res)];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_GETTING_PAIR)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Adds TOKEN/ETH liquidity to pool
     *
     * @param tokenAddress string - Token ID to be paird with ETH
     * @param amountTokenDesired BigNumber - amount of tokens desired
     * @param amountTokenMin BigNumber - min number of tokens
     * @param amountETHMin BigNumber - amount of ETH
     * @param sendValue the send value
     * @returns ContractTransaction
     */
    VerseRouterController.prototype.addLiquidityETH = function (tokenAddress, amountTokenDesired, amountTokenMin, amountETHMin, sendValue) {
        return __awaiter(this, void 0, void 0, function () {
            var address, transaction, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this._signer.getAddress()];
                    case 1:
                        address = _a.sent();
                        return [4 /*yield*/, this._routerContract.addLiquidityETH(tokenAddress, amountTokenDesired, amountTokenMin, amountETHMin, address, this.getFutureTimeStamp(30), { value: sendValue })];
                    case 2:
                        transaction = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(transaction)];
                    case 3:
                        error_2 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_ADDING_LIQUIDITY_ETH)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Adds token pair liquidity
     *
     * @param tokenAId string - ID of the token a
     * @param tokenBId string - ID of the token b
     * @param amountADesired BigNumber - amount desired for token A
     * @param amountBDesired BigNumber - amount desired for token B
     * @param amountAMin BigNumber - min amount for token A
     * @param amountBMin BigNumber - min amount for token B
     * @returns ContractTransaction
     */
    VerseRouterController.prototype.addLiquidity = function (tokenAId, tokenBId, amountADesired, amountBDesired, amountAMin, amountBMin) {
        return __awaiter(this, void 0, void 0, function () {
            var address, transaction, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this._signer.getAddress()];
                    case 1:
                        address = _a.sent();
                        return [4 /*yield*/, this._routerContract.addLiquidity(tokenAId, tokenBId, amountADesired, amountBDesired, amountAMin, amountBMin, address, this.getFutureTimeStamp(30))];
                    case 2:
                        transaction = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(transaction)];
                    case 3:
                        error_3 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_ADDING_LIQUIDITY)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Removes liquidity from given tokens
     *
     * @param tokenAId string - ID of token a
     * @param tokenBId string - ID of token b
     * @param liquidityToWithdraw BigNubmer - amount of liquidity to withdraw
     * @param amountAMin BigNumber - min amount for token a
     * @param amountBMin BigNumber - min amount for token b
     * @returns ContractTransaction
     */
    VerseRouterController.prototype.removeLiquidity = function (tokenAId, tokenBId, liquidityToWithdraw, amountAMin, amountBMin) {
        return __awaiter(this, void 0, void 0, function () {
            var address, transaction, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this._signer.getAddress()];
                    case 1:
                        address = _a.sent();
                        return [4 /*yield*/, this._routerContract.removeLiquidity(tokenAId, tokenBId, liquidityToWithdraw, amountAMin, amountBMin, address, this.getFutureTimeStamp(30))];
                    case 2:
                        transaction = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(transaction)];
                    case 3:
                        error_4 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_REMOVING_LIQUIDITY)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Remove TOKEN/ETH liquidity from pool
     *
     * @param tokenAddress string - Token ID to be paird with ETH
     * @param liquidityToWithdraw BigNumber - amount of tokens to withdraw
     * @param amountTokenMin BigNumber - min number of tokens
     * @param amountETHMin BigNumber - amount of ETH
     * @returns ContractTransaction
     */
    VerseRouterController.prototype.removeLiquidityETH = function (tokenAddress, liquidityToWithdraw, amountTokenMin, amountETHMin) {
        return __awaiter(this, void 0, void 0, function () {
            var address, transaction, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this._signer.getAddress()];
                    case 1:
                        address = _a.sent();
                        return [4 /*yield*/, this._routerContract.removeLiquidityETH(tokenAddress, liquidityToWithdraw, amountTokenMin, amountETHMin, address, this.getFutureTimeStamp(30))];
                    case 2:
                        transaction = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(transaction)];
                    case 3:
                        error_5 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_REMOVING_LIQUIDITY)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Calculates gas cost for adding TOKEN/ETH liquidity to pool
     *
     * @param tokenAddress string - Token ID to be paird with ETH
     * @param amountTokenDesired BigNumber - amount of tokens desired
     * @param amountTokenMin BigNumber - min number of tokens
     * @param amountETHMin BigNumber - amount of ETH
     * @param sendValue the send value
     * @returns BigNumber
     */
    VerseRouterController.prototype.estimateGasAddLiquidityETH = function (tokenAddress, amountTokenDesired, amountTokenMin, amountETHMin, sendValue) {
        return __awaiter(this, void 0, void 0, function () {
            var address, gasUnits, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this._signer.getAddress()];
                    case 1:
                        address = _a.sent();
                        return [4 /*yield*/, this._routerContract.estimateGas.addLiquidityETH(tokenAddress, amountTokenDesired, amountTokenMin, amountETHMin, address, this.getFutureTimeStamp(30), { value: sendValue })];
                    case 2:
                        gasUnits = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(gasUnits)];
                    case 3:
                        error_6 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_ESTIMATING_GAS)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets gas price for adding token pair liquidity
     *
     * @param tokenAId string - ID of the token a
     * @param tokenBId string - ID of the token b
     * @param amountADesired BigNumber - amount desired for token A
     * @param amountBDesired BigNumber - amount desired for token B
     * @param amountAMin BigNumber - min amount for token A
     * @param amountBMin BigNumber - min amount for token B
     * @returns BigNumber
     */
    VerseRouterController.prototype.estimateGasAddLiquidity = function (tokenAId, tokenBId, amountADesired, amountBDesired, amountAMin, amountBMin) {
        return __awaiter(this, void 0, void 0, function () {
            var address, gasUnits, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this._signer.getAddress()];
                    case 1:
                        address = _a.sent();
                        return [4 /*yield*/, this._routerContract.estimateGas.addLiquidity(tokenAId, tokenBId, amountADesired, amountBDesired, amountAMin, amountBMin, address, this.getFutureTimeStamp(30))];
                    case 2:
                        gasUnits = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(gasUnits)];
                    case 3:
                        error_7 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_ESTIMATING_GAS)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return VerseRouterController;
}());
exports.VerseRouterController = VerseRouterController;
